<template>
    <div class="filters-panel text-black" :style="panelStyle">
      <div v-if="currentLevel === 0">
        <header class="header">
            <span>Overtime - Hours</span>
            <img @click="close" class="icon x-icon" src="../assets/x-icon.svg" />
        </header>
        <ul class="selections">
            <li>
                <span>Compare Dates...</span>
            </li>
          <li>
            <span>Group By</span>
            <span class="text-primary">{{ selection }} <img class="icon chevron-icon" src="../assets/chevron-right-icon.svg" /></span>
          </li>
          <li>
            <span>Set Threshold</span>
          </li>
          <li>
            <span>Maximize</span>
          </li>
        </ul>

      <screen-link left="0%" top="42%" width="99%" height="15.5%" dot-class="dot-right-center" data-tgt="" @click.native="setLevel(1)"></screen-link>

      <screen-link left="0%" top="59%" width="40%" height="15.5%" data-tgt="pullout-labor-cost-threshold" :data-init-info="(this.selection === 'Top supervisors')?'17':'33'" @click.native="showPullout"></screen-link>
        </div>
      <div v-if="currentLevel === 1">
        <header class="header">
          <span class="v-center" @click="setLevel(0)"><svg class="back-icon" viewBox="0 0 7 18" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path fill="#404040" d="M5.208 14.82c.224.24.58.24.8 0l.795-.859a.63.63 0 0 0 0-.857L2.957 9.017l3.876-4.121a.635.635 0 0 0 0-.859l-.795-.86a.542.542 0 0 0-.801 0L.165 8.586a.647.647 0 0 0 0 .86l5.043 5.374z"></path></svg> <span> Group By</span></span>
          <img @click="close" class="icon x-icon" src="../assets/x-icon.svg" />
        </header>
        <ul class="selections">
          <li :class="(selection==='Check date')?'selected':''">
            <span>Check date</span>
          </li>
          <li>
            <span>Period and date</span>
          </li>
          <li>
            <span>Top organizations (level 1)</span>
          </li>
          <li>
            <span>Top positions</span>
          </li>
          <li>
            <span>Top locations</span>
          </li>
          <li :class="(selection==='Top supervisors')?'selected':''">
            <span>Top supervisors</span>
          </li>
          <li>
            <span>Top companies</span>
          </li>
          <li>
            <span>Custom</span>
          </li>

        </ul>

        <screen-link left="0%" top="14.5%" width="100%" height="9%" dot-class="dot-right-center" data-tgt="reports-labor-cost" @click.native="onLinkClick"></screen-link>


        <screen-link left="0%" top="67%" width="100%" height="9%" dot-class="dot-right-center" data-tgt="reports-labor-cost-overtime-by-supervisor" @click.native="onLinkClick"></screen-link>
      </div>

    </div>
</template>

<script>

    import ScreenLink from "@/components/ScreenLink";
    export default {
        name: "overtime-options-panel",
        components: {ScreenLink},
        props: {
            left: {
                default: "0em"
            },

            top: {
                default: "0em"
            },

            width: {
                default: "6em"
            },
          selection: {
            default: "Check date"
          }
        },
        data: function () {
            return {
                isInactive: true,
                hasChanges: false,
                title: "Filters",
                currentLevel: 0,
                currentCategory: 0,




            }
        },
        methods: {
            close: function(){
                this.setLevel(0);
                this.$emit('close');
            },

          onLinkClick: function(e){
            this.$emit('link',e)
          },

          showPullout: function(e){
            this.$emit('pullout',e)
          },



            apply: function(){
                this.hasChanges = false;
                this.$emit('apply', this.selections);
            },

            reset: function(){
                this.selections.forEach((selection)=>{

                    selection.selections.forEach((item)=>{
                        item.selected = true;
                    })

                    selection.selection = "All";

                })

                this.hasChanges = true;
            },

            setLevel: function(level){
              console.log("Set Level", level)
                this.currentLevel = level;
            },

            setCategory: function(index){
                console.log("set Category ", index);
                this.currentCategory = index;
                this.currentLevel = 1;
            },

            toggleItem: function(index){
                console.log("toggle", index);
                this.hasChanges = true;
                let item = this.selections[this.currentCategory].selections[index];

                let selected = [];

                if(index){
                    item.selected = !item.selected;
                    if(!item.selected){
                        this.selections[this.currentCategory].selections[0].selected = false;
                    }

                    this.selections[this.currentCategory].selections.forEach((selection)=>{
                        if(selection.selected){
                            selected.push(selection.title);
                        }
                    })
                }else{
                    item.selected = !item.selected;
                    this.selections[this.currentCategory].selections.forEach((selection)=>{
                        selection.selected = item.selected;
                        if(selection.selected){
                            selected.push(selection.title);
                        }
                    })
                }


                if(selected.length){

                    if(selected.length < this.selections[this.currentCategory].selections.length){
                        if(selected.length == 1){
                            this.selections[this.currentCategory].selection = selected[0];
                        }else{
                            this.selections[this.currentCategory].selection = selected.length + " Items";
                        }

                    }else{
                        this.selections[this.currentCategory].selection = "All"
                    }
                }else{
                    this.selections[this.currentCategory].selection = "";
                }


            }
        },
        computed: {
            panelStyle: function(){
                return {
                    width: this.width,
                    top: this.top,
                    left: this.left
                }
            },


            currentSelections: function(){

                if(this.currentLevel){
                    return this.selections[this.currentCategory].selections;

                }else{
                    return this.selections;
                }
            }

        }
    }
</script>

<style scoped>


    .filters-panel {
        font-size: 0.9em;
        position: absolute;

        background-color: white;
        box-shadow: 0 2px 5px rgba(0,0,0,0.3);
    }

    .header {
        display: flex;
        justify-content: space-between;
        padding: 1em 1em;
    }

    .v-center {
      display: flex;
      align-items: center;
    }

    .footer {
        display: flex;
        justify-content: space-between;
        align-items: center;

        border-top: 1px solid #D8D8D8;
        padding: 0.5em 1em;


    }

    .selections {
        margin: 0;
        margin-bottom: 0.75em;
        padding: 0;
        list-style: none;
    }

    .selections li {
        margin: 0;
        padding: 0.75em 1em;
        display: flex;
        justify-content: space-between;
        align-items: center;


    }

    .selections.checkboxes li {
        margin: 0;
        padding: 0.75em 1em;
        display: flex;
        justify-content: flex-start;
        align-items: center;


    }

    li.selected {
      color: #0369b1;
      background: #e5f0f7;
    }

    .x-icon {
      cursor: pointer;
    }

    .icon {
        height: 1em;
    }

    .back-icon {
      height: 1.5em;
      width: 1em;
      margin-right: 0.2em;
    }

    .icon.chevron-icon {
        height: 0.9em;
        margin-left: 0.5em;
    }

    .icon.chevron-icon-left {
        transform: rotate(180deg);
    }

    .check-box {
        margin-right: 0.75em;
        margin-left: 0.5em;
    }

</style>
